<script setup lang="ts">
import { TermsOfUsePage } from '@features/legal'
</script>

<template>
  <terms-of-use-page />
</template>
